(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["products-mega-menu"] && !Shopify.designMode) return;
  try {
    class ProductsMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('[data-pm-trigger]');
      this.panel = this.querySelector('[data-pm-panel]');
      this.l1Links = Array.from(this.querySelectorAll('[data-pm-l1-link]'));
      this.l2Links = Array.from(this.querySelectorAll('[data-pm-l2-link]'));
      this.l2Panes = Array.from(this.querySelectorAll('[data-pm-l2-pane]'));
      this.l3Panes = Array.from(this.querySelectorAll('[data-pm-l3-pane]'));
      this.activeL1 = 0;
      this.activeL2 = 0;
      this.open = false;
      this.hoverTimer = null;
    }

    connectedCallback() {
      this.trigger.addEventListener('click', this.toggle.bind(this));
      this.l1Links.forEach((link) => {
        link.addEventListener('mouseenter', this.onL1Hover.bind(this));
        link.addEventListener('focus', this.onL1Focus.bind(this));
        link.addEventListener('click', this.onL1Click.bind(this));
      });
      this.l2Links.forEach((link) => {
        link.addEventListener('mouseenter', this.onL2Hover.bind(this));
        link.addEventListener('focus', this.onL2Hover.bind(this));
        link.addEventListener('click', this.onL2Click.bind(this));
      });
      document.addEventListener('keydown', this.onKeyDown.bind(this));
      document.addEventListener('click', this.onDocClick.bind(this));
    }

    toggle(event) {
      event.preventDefault();
      if (this.open) this.close();
      else this.openPanel();
    }

    openPanel() {
      this.open = true;
      this.panel.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setActive(this.activeL1, this.activeL2);
    }

    close() {
      this.open = false;
      this.panel.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-mobile-l2', 'is-mobile-l3');
    }

    onL1Hover(event) {
      if (window.matchMedia('(max-width: 989px)').matches) return;
      const idx = parseInt(event.currentTarget.dataset.pmL1Link, 10);
      clearTimeout(this.hoverTimer);
      this.hoverTimer = setTimeout(() => this.setActive(idx, 0), 70);
    }

    onL1Focus(event) {
      const idx = parseInt(event.currentTarget.dataset.pmL1Link, 10);
      this.setActive(idx, 0);
    }

    onL1Click(event) {
      const idx = parseInt(event.currentTarget.dataset.pmL1Link, 10);
      const url = event.currentTarget.getAttribute('href');
      if (window.matchMedia('(max-width: 989px)').matches) {
        event.preventDefault();
        this.setActive(idx, 0);
        this.classList.add('is-mobile-l2');
        this.classList.remove('is-mobile-l3');
      } else {
        if (url === '#') event.preventDefault();
        this.setActive(idx, 0);
      }
    }

    onL2Hover(event) {
      if (window.matchMedia('(max-width: 989px)').matches) return;
      const parts = event.currentTarget.dataset.pmL2Link.split('-');
      this.setActive(parseInt(parts[0], 10), parseInt(parts[1], 10));
    }

    onL2Click(event) {
      const parts = event.currentTarget.dataset.pmL2Link.split('-');
      const l1 = parseInt(parts[0], 10);
      const l2 = parseInt(parts[1], 10);
      if (window.matchMedia('(max-width: 989px)').matches) {
        const pane = this.l3Panes.find((p) => p.dataset.pmL3Pane === l1 + '-' + l2);
        if (pane && pane.childElementCount > 0) {
          event.preventDefault();
          this.setActive(l1, l2);
          this.classList.remove('is-mobile-l2');
          this.classList.add('is-mobile-l3');
        }
      } else {
        this.setActive(l1, l2);
      }
    }

    setActive(l1, l2) {
      this.activeL1 = l1;
      this.activeL2 = l2;
      this.querySelectorAll('.pm__l1-item').forEach((item) => {
        item.classList.toggle('is-active', parseInt(item.dataset.pmL1, 10) === l1);
      });
      this.l2Panes.forEach((pane) => {
        pane.classList.toggle('is-active', parseInt(pane.dataset.pmL2Pane, 10) === l1);
      });
      this.l3Panes.forEach((pane) => {
        pane.classList.toggle('is-active', pane.dataset.pmL3Pane === l1 + '-' + l2);
      });
      const activePane = this.querySelector('[data-pm-l2-pane="' + l1 + '"]');
      if (activePane) {
        activePane.querySelectorAll('.pm__l2-item').forEach((item) => {
          item.classList.toggle('is-active', parseInt(item.dataset.pmL2, 10) === l2);
        });
      }
    }

    onKeyDown(event) {
      if (!this.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        this.trigger.focus();
      }
    }

    onDocClick(event) {
      if (!this.open) return;
      if (this.contains(event.target)) return;
      this.close();
    }
  }

  if (!customElements.get('products-mega-menu')) {
    customElements.define('products-mega-menu', ProductsMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
